import { IInputElement } from '../../types';

import { InputTextElement } from '../../form-inputs';

type TLastNameInputFieldProps = Pick<
  IInputElement,
  | 'className'
  | 'classNameInput'
  | 'classNameLabel'
  | 'error'
  | 'label'
  | 'name'
  | 'onBlurCallback'
  | 'onChangeCallback'
  | 'onError'
  | 'value'
>;

/**
 * -----------------------------------------------------------------------------
 * This is used to capture the last name of a person or organization,
 * and tries to add constraints that are used to validate the expected format of
 * a valid person's first name.
 */
export function LastNameInputField({
  className,
  classNameInput,
  classNameLabel,
  error,
  label,
  name,
  onBlurCallback,
  onChangeCallback,
  onError,
  value,
}: TLastNameInputFieldProps) {
  return (
    <InputTextElement
      className={className}
      classNameInput={classNameInput}
      classNameLabel={classNameLabel}
      constraints={{
        feedbackLabel: 'Last Name',
        maxLength: 50,
        minLength: 2,
        required: true,
        format: 'person-name',
      }}
      error={error}
      hasClearButton
      label={label}
      name={name}
      onBlurCallback={onBlurCallback}
      onChangeCallback={onChangeCallback}
      onError={onError}
      placeholder="Please enter a last name"
      showIsRequired={false}
      type="text"
      value={value}
    />
  );
}
